export const products = [
  {
    code: '7A-01',
    images: ['grinder open.png', 'grinder half.png', 'grinder detail 1.jpeg', 'grinder detail 2.jpeg'],
    price: 65,
    info: `7" vinyl adapter that doubles as a grinder`
  },
];
